import { createAction } from 'redux-actions'

import { LOGIN, LOGIN_MFA, LOGOUT, ME } from 'constants/auth-constants'
import { clearPaginatedTableMetaCache } from 'hooks/usePaginatedTableMeta'
import { deleteCustomerCookie } from 'utils/cookies'
import { get, post } from 'utils/http'
import { navigate } from 'utils/navigation'

// Minimal async-action helper: dispatches _START/_SUCCESS({ body })/_FAIL({ error }) and never rejects (views read `.payload.{ body, error }`).
// The request payload `p` is deliberately NOT spread into the actions — for login it holds the plaintext password, which must never reach the Redux store/devtools.
const authAction =
  (type: string, request: (p: any) => Promise<any>) =>
  (p: any = {}) =>
  async (d: any) => {
    d(createAction(`${type}_START`)())
    try {
      const body = await request(p)
      return d(createAction(`${type}_SUCCESS`)({ body }))
    } catch (error) {
      return d(createAction(`${type}_FAIL`)({ error }))
    }
  }

const loginAction = authAction(LOGIN, p => post('/management/oauth/token', p))

export const login = (p: any) => (d: any) => {
  // Not just on logout: an expired session redirects to /login without dispatching logout.
  clearPaginatedTableMetaCache()
  return d(loginAction({ grant_type: 'password', ...p }))
}

export const loginMfa = authAction(LOGIN_MFA, p => post('/management/oauth/mfa', p))

const logoutAction = authAction(LOGOUT, () => post('/management/oauth/logout'))

export const logout =
  (path = '/login') =>
  async (d: any) => {
    await d(logoutAction())
    deleteCustomerCookie()
    clearPaginatedTableMetaCache()
    navigate(path, { replace: true })
  }

export const me = authAction(ME, () => get('/management/me'))
